<template>
    <CardCarousel
        :items="props.games"
        :rows="1"
        withBadges
        fixedBaseSize="246rem"
        roundScrollButtons
    >
        <template #default="{ index, item: game, className }">
            <GameCardTopPlaygama
                :game="game"
                :data-interface-target="`game-number-${index + 1}`"
                :gameLinkTarget="props.gameLinkTarget"
                :class="className"
            />
        </template>
    </CardCarousel>
</template>
<script lang="ts" setup>
import CardCarousel from '@/components/CardCarousel.vue'
import { type LinkTarget, ShortGameTypePlaygamaTop } from '@/types'

import GameCardTopPlaygama from './GameCardTopPlaygama.vue'

const props = defineProps<{
    games: ShortGameTypePlaygamaTop[] | undefined[]
    gameLinkTarget: LinkTarget | undefined
}>()
</script>
